import React from 'react';
import { useAllSentShiftChangeRequestsQuery } from '../../../__generated__/graphql';
import ServerError from '../../../../../components/ServerError';
import { mapSentShiftChangeRequests } from './mappings';
import { SentShiftChangeRequestsTable } from './SentShiftChangeRequestsTable';

export const SentShiftChangeRequests: React.FC = () => {
  const { data, loading, error } = useAllSentShiftChangeRequestsQuery({});

  if (error) {
    return <ServerError />;
  }

  const requests = mapSentShiftChangeRequests(
    data?.me.shiftChangeRequestsFromMe ?? [],
  );

  return <SentShiftChangeRequestsTable requests={requests} loading={loading} />;
};
